import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import IdleModal from "./IdleModal";

/**
 * idleWarning num of minutes before warning pops up
 * idleLogout num of minutes before we logout user.
 */
export default withRouter(
  injectIntl(
    ({
      confirmLabel,
      closeLabel,
      idleWarning = 0,
      idleLogout = 0,
      redirectTo,
      warningText,
    }) => {
      const [timer, setTimer] = useState(0);
      const [timerId, setTimerId] = useState(null);
      const [warning, setWarning] = useState(false);

      useEffect(() => {
        if (idleLogout !== 0) {
          window.addEventListener("mousemove", resetTimer);
          window.addEventListener("keypress", resetTimer);
          window.addEventListener("ontouchstart", resetTimer);
          window.addEventListener("onclick", resetTimer);

          if (timerId) {
            clearInterval(timerId);
          }

          const id = setInterval(() => setTimer((timer) => timer + 1), 1000);
          console.log("Idle setTimerId ", id);
          setTimerId(id);
        }

        return () => {
          if (idleLogout !== 0) {
            window.removeEventListener("mousemove", resetTimer);
            window.removeEventListener("keypress", resetTimer);
            window.removeEventListener("ontouchstart", resetTimer);
            window.removeEventListener("onclick", resetTimer);
            clearInterval(timerId);
          }
        };
      }, [idleLogout]); // <-- warning as dep is required to make resetTimer work

      const resetTimer = () => {
        setTimer(0);
      };

      // watch for timeout values
      useEffect(() => {
        if (timer > idleLogout * 60 - idleWarning * 60) {
          setWarning(true);
        }
      }, [timer]);

      if (idleLogout === 0) {
        return null;
      }

      if (warning) {
        return (
          <IdleModal
            confirmLabel={confirmLabel}
            confirm={() => setWarning(false)}
            closeLabel={closeLabel}
            idleWarning={idleWarning}
            redirectTo={redirectTo}
            warningText={warningText}
          />
        );
      } else {
        return null;
      }
    }
  )
);
